/**
 * @generated SignedSource<<2879df36b50ed742c92c25350dd34e08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserArea_user$data = {
  readonly email: string;
  readonly " $fragmentType": "UserArea_user";
};
export type UserArea_user$key = {
  readonly " $data"?: UserArea_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserArea_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserArea_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d3d6e22dc7304fe6788bb6eaebe39bfc";

export default node;
